import React, { FC } from 'react'
import { FieldArray, FormikHelpers } from 'formik'
import { isFulfilled } from '@reduxjs/toolkit'

import Form from '../../components/Form'
import CustomButton from '../../components/UI/Buttons/CustomButton'
import TextInput from '../../components/UI/Inputs/TextInput'
import SelectInput from '../../components/UI/Inputs/SelectInput'

import { useDispatch, useSelector } from '../../store'
import { inviteToAgencyThunk } from '../../store/agency/thunks'
import TrashIcon from '../../components/UI/Icons/Trash'

interface CreateAgencyStep2Props {
  goForward: () => void
  skipCreation?: () => void
  inProgress: boolean
}

const CreateAgencyStep2: FC<CreateAgencyStep2Props> = ({ inProgress, goForward, ...props }) => {
  const dispatch = useDispatch()
  const agencyRoles = useSelector((state) => state.agency.roles)

  const setUpForm = {
    initialValues: {
      invite_to_agency: [{ name: '', email: '', agency_role: '' }]
    },
    validation: 'invite_members',
    onSubmit: async (values: any, actions: FormikHelpers<any>) => {
      const inviteRequests = values.invite_to_agency.map((member: any) =>
        dispatch(inviteToAgencyThunk(member))
      )
      const inviteResponses = await Promise.all(inviteRequests)
      // TODO check all invitations
      if (!inviteResponses[0] || isFulfilled(inviteResponses[0] as any)) {
        goForward()
      }
    }
  }

  return (
    <div className='agency-creation-step step-2'>
      <div className='agency-creation-step__title'>Invite team members</div>
      <div className='agency-creation-step__description'>
        You can always add or remove people under the "Project Settings" menu.
      </div>
      <Form {...setUpForm}>
        <div className='agency-creation-step__invite-rows'>
          <FieldArray
            name='invite_to_agency'
            render={({ push, remove, form: { values, ...formRest }, ...rest }) => (
              <>
                {values.invite_to_agency &&
                  values.invite_to_agency.map((user: any, index: number) => (
                    <div key={index} className='agency-creation-step__invite-row'>
                      <TextInput
                        label='Name'
                        name={`invite_to_agency.${index}.name`}
                        placeholder='Name'
                      />
                      <TextInput
                        label='Email'
                        name={`invite_to_agency.${index}.email`}
                        placeholder='Email'
                      />
                      <SelectInput
                        label='Agency role'
                        name={`invite_to_agency.${index}.agency_role`}
                        placeholder='Role'
                        options={agencyRoles}
                      />
                      <CustomButton
                        type='button'
                        className='agency-creation-step__invite-row__delete'
                        button='delete'
                        onClick={() => remove(index)}
                      >
                        <TrashIcon />
                      </CustomButton>
                    </div>
                  ))}
                <CustomButton
                  type='button'
                  className='agency-creation-step__button-add'
                  button='subtle'
                  onClick={() => push({ name: '', email: '', agency_role: '' })}
                >
                  Add Member
                </CustomButton>
              </>
            )}
          />
        </div>

        <div className='agency-creation-step__buttons'>
          <CustomButton type='button' button='primary' size='big' onClick={goForward}>
            Skip
          </CustomButton>
          <CustomButton inProgress={inProgress} button='primary' size='big' type='submit'>
            Submit
          </CustomButton>
        </div>
      </Form>
    </div>
  )
}

export default CreateAgencyStep2
